import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';
import { Breadcrumb } from '../presentation/Breadcrumb';
import { LensDetailLeft } from '../presentation/LensDetailLeft';
import { LensDetailRight } from '../presentation/LensDetailRight';
import { ProductTab } from '../presentation/ProductTab';
import { RecentlyViewed } from '../presentation/RecentlyViewed';

export const Lens = () => {
  return (
    <>
      <Header />
      <Breadcrumb />
      <div className="xl:px-16 px-8 flex flex-col lg:flex-row gap-10">
        <LensDetailLeft />
        <LensDetailRight />
      </div>
      <ProductTab />
      <RecentlyViewed />
      <Footer />
    </>
  )
}